import { ComposableMap, Geographies, Geography } from 'react-simple-maps';

const GEO_URL = "https://cdn.jsdelivr.net/npm/world-atlas@2/countries-110m.json";

// ISO numeric to alpha-2 mapping for the territories we care about
// react-simple-maps uses numeric codes from topojson
// This component accepts visitedCodes as a Set of alpha-2 codes
// and visitCounts as an object { "US": 5, "JP": 2, ... }

export default function WorldMap({ visitedCodes, visitCounts }) {
  return (
    <ComposableMap
      projectionConfig={{ scale: 153, center: [15, 5] }}
      style={{ width: '100%', height: 'auto', display: 'block' }}
    >
      <Geographies geography={GEO_URL}>
        {({ geographies }) =>
          geographies.map(geo => {
            const alpha2 = getAlpha2(geo.properties.name);
            const visited = visitedCodes.has(alpha2);
            const visits = visitCounts[alpha2] || 0;

            // Opacity scales with visit count: 1 visit = 0.6, 3+ = 1.0
            const opacity = visited
              ? Math.min(0.5 + (visits * 0.15), 1.0)
              : 1;

            return (
              <Geography
                key={geo.rsmKey}
                geography={geo}
                fill={visited ? `rgba(16, 185, 129, ${opacity})` : '#383838'}
                stroke="rgba(255,255,255,0.05)"
                strokeWidth={0.5}
                style={{
                  default: { outline: 'none' },
                  hover: { outline: 'none', fill: visited ? '#10B981' : '#444444' },
                  pressed: { outline: 'none' },
                }}
              />
            );
          })
        }
      </Geographies>
    </ComposableMap>
  );
}

// Map country names from topojson to ISO alpha-2 codes
// This needs to cover all 67 of Werner's countries
function getAlpha2(name) {
  const map = {
    'United States of America': 'US',
    'Canada': 'CA',
    'Mexico': 'MX',
    'Bahamas': 'BS',
    'Costa Rica': 'CR',
    'Guatemala': 'GT',
    'Dominican Rep.': 'DO',
    'El Salvador': 'SV',
    'Panama': 'PA',
    'Brazil': 'BR',
    'Colombia': 'CO',
    'South Africa': 'ZA',
    'Namibia': 'NA',
    'Botswana': 'BW',
    'Zambia': 'ZM',
    'Zimbabwe': 'ZW',
    'Tanzania': 'TZ',
    'Mauritius': 'MU',
    'eSwatini': 'SZ',
    'Swaziland': 'SZ',
    'Dem. Rep. Congo': 'CD',
    'Ethiopia': 'ET',
    'Japan': 'JP',
    'China': 'CN',
    'India': 'IN',
    'Sri Lanka': 'LK',
    'Pakistan': 'PK',
    'Thailand': 'TH',
    'Vietnam': 'VN',
    'Indonesia': 'ID',
    'Philippines': 'PH',
    'Cambodia': 'KH',
    'South Korea': 'KR',
    'Korea': 'KR',
    'Russia': 'RU',
    'Georgia': 'GE',
    'United Arab Emirates': 'AE',
    'Qatar': 'QA',
    'Turkey': 'TR',
    'England': 'GB',
    'United Kingdom': 'GB',
    'France': 'FR',
    'Germany': 'DE',
    'Spain': 'ES',
    'Portugal': 'PT',
    'Netherlands': 'NL',
    'Belgium': 'BE',
    'Switzerland': 'CH',
    'Italy': 'IT',
    'Malta': 'MT',
    'Croatia': 'HR',
    'Montenegro': 'ME',
    'Czech Rep.': 'CZ',
    'Czechia': 'CZ',
    'Sweden': 'SE',
    'Finland': 'FI',
    'Latvia': 'LV',
    'Estonia': 'EE',
    'Lithuania': 'LT',
    'Hungary': 'HU',
    'Greece': 'GR',
    'Denmark': 'DK',
    'Albania': 'AL',
    'Taiwan': 'TW',
    'Hong Kong': 'HK',
    'Macau': 'MO',
  };
  return map[name] || null;
}
